import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { BaseButtonStyledProps } from "../types";

export const getButtonBorderColor = (props: BaseButtonStyledProps) => {
    if (props.appearance === "secondary-outlined") {
        return `${color("color--border--neutral--weak")}`;
    } else {
        // Since some buttons use a border, we'll add a transparent border to all buttons by
        // default. This helps our focus ring code to have a consistent target radius.
        return `transparent`;
    }
};

const underlineOffset = themed({
    "lodestar-light": "1px",
    "ursa-light": "2px",
});

export const getUnderlineOffset = ({ themeMode }: BaseButtonStyledProps): string => {
    return underlineOffset(themeMode);
};
